import { Link, Navigate } from "react-router";
import { AppLayout } from "../components/layout/AppLayout";
import { useAuth0 } from "@auth0/auth0-react";
import { CHP_LESSON_CONFIG } from "../data/lesson-config";
import {
  Card,
  CardDescription,
  CardHeader,
  CardTitle,
} from "../components/ui/card";
import { Button } from "../components/ui/button";
import { Skeleton } from "../components/ui/skeleton";
import { useState, useEffect, useContext } from "react";
import { UserContext } from "../lib/client/state/UserProvider";

export const Lessons = () => {
  const { isAuthenticated } = useAuth0();
  const [loadedImages, setLoadedImages] = useState<Record<string, boolean>>({});
  const { user, selectedProgram } = useContext(UserContext);

  const lessons = selectedProgram === "chp" ? CHP_LESSON_CONFIG : [];
  const lastLessonCompleted = user?.programs.find(
    (p) => p.program === selectedProgram
  )?.lastLessonCompleted;

  // Preload images
  useEffect(() => {
    lessons.forEach((lesson) => {
      const img = new Image();
      img.src = lesson.image;
      img.onload = () => {
        setLoadedImages((prev) => ({ ...prev, [lesson.image]: true }));
      };
    });
  }, []);

  if (!isAuthenticated) {
    return <Navigate to="/" />;
  }

  return (
    <AppLayout>
      <div>
        {[...lessons]
          .slice(0, lastLessonCompleted === null ? 1 : lastLessonCompleted + 2)
          .reverse()
          .map((lesson, index) => (
            <Card
              key={lesson.title}
              className="mb-4"
              style={
                index === 0
                  ? {
                      background: `linear-gradient(to bottom, #A966AA20, #fafafa)`,
                    }
                  : undefined
              }
            >
              <CardHeader className="flex flex-col md:flex-row items-center gap-4">
                {!loadedImages[lesson.image] ? (
                  <Skeleton className="w-24 h-24 rounded-md mr-4" />
                ) : (
                  <Link to={`/lessons/${selectedProgram}/${lesson.lessonCode}`}>
                    <img
                      src={lesson.image}
                      alt={lesson.title}
                      className="w-24 h-24 object-cover rounded-md mr-4"
                      loading="lazy"
                      decoding="async"
                    />
                  </Link>
                )}
                <div className="flex-1">
                  <CardDescription>{lesson.subtitle}</CardDescription>

                  <CardTitle className="mb-2">
                    {" "}
                    <Link
                      to={`/lessons/${selectedProgram}/${lesson.lessonCode}`}
                    >
                      {lesson.title}
                    </Link>
                  </CardTitle>

                  <div className="text-sm text-gray-500 max-w-4xl mr-4">
                    {lesson.blurb}
                  </div>
                </div>
                <div>
                  <Button asChild>
                    <Link
                      to={`/lessons/${selectedProgram}/${lesson.lessonCode}`}
                    >
                      View {lesson.subtitle}
                    </Link>
                  </Button>
                </div>
              </CardHeader>
            </Card>
          ))}
        <div className="h-10" />
      </div>
    </AppLayout>
  );
};
